import React, { useState } from "react";

/**
 * Renders a category's image (preferred) and falls back to its emoji icon
 * if the image is missing or fails to load. Used by both desktop and mobile
 * category tiles for a consistent look.
 *
 * Props:
 *   parent      — parent category object from buildParents()
 *   size        — Tailwind class for both width AND height (square),
 *                 e.g. "h-14 w-14". Default "h-14 w-14".
 *   grayscale   — apply grayscale filter (used for "coming soon" parents)
 *   className   — extra wrapper classes (e.g. "group-hover:scale-110")
 */
const CategoryMedia = ({ parent, size = "h-14 w-14", grayscale = false, className = "" }) => {
    const [errored, setErrored] = useState(false);
    const hasImage = parent?.image && !errored;
    return (
        <div
            className={`${size} rounded-xl overflow-hidden bg-neutral-100 flex items-center justify-center shrink-0 ${grayscale ? "grayscale opacity-80" : ""} ${className}`}
            aria-hidden="true"
        >
            {hasImage ? (
                <img
                    src={parent.image}
                    alt={parent.label || ""}
                    onError={() => setErrored(true)}
                    loading="lazy"
                    className="w-full h-full object-cover scale-[1.18]"
                />
            ) : (
                <span className="text-3xl select-none">{parent?.icon || "🛒"}</span>
            )}
        </div>
    );
};

export default CategoryMedia;
